export default "__VITE_ASSET__DBGbQHJd__"